<template>
  <div class="d-flex flex-column h-100">
    <div
      class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom"
    >
      <strong>{{ $t('whatsapp.conversations') }}</strong>
      <b-button
        size="sm"
        variant="outline-secondary"
        :disabled="loading"
        @click="$emit('refresh')"
      >
        {{ $t('whatsapp.refresh') }}
      </b-button>
    </div>

    <div class="flex-grow-1 overflow-auto">
      <div v-if="loading && !conversations.length" class="text-center py-4">
        <b-spinner small />
      </div>
      <div
        v-else-if="!conversations.length"
        class="text-muted text-center py-4 px-3"
      >
        {{ $t('whatsapp.no-conversations') }}
      </div>
      <b-list-group v-else flush>
        <conversation-list-item
          v-for="conversation in conversations"
          :key="conversation.id"
          :conversation="conversation"
          :active="conversation.id === selectedId"
          @select="$emit('select', $event)"
        />
      </b-list-group>
    </div>

    <div v-if="truncated" class="small text-muted px-3 py-2 border-top">
      {{ $t('whatsapp.showing-n-of', { shown: conversations.length, total }) }}
    </div>
  </div>
</template>

<script>
import ConversationListItem from './ConversationListItem.vue';

export default {
  name: 'ConversationList',
  components: { ConversationListItem },
  props: {
    conversations: { type: Array, required: true },
    selectedId: { type: String, default: null },
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
  computed: {
    truncated() {
      return this.total > this.conversations.length;
    },
  },
};
</script>
